import React from 'react';
import {
    Modal,
    Input,
    Form,
    Select,
    Tabs,
    Button
} from 'antd';

import DetalleProductoServicioModal from './DetalleProductoServicioModal';
import dialog from "../../../common/utility/dialog";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        debugger
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idProducto: values.idProducto.key,
                    serie: values.serie,
                    documento: values.documento,
                    observacion: values.descripcion,
                    recetaDetalles:this.fetchDetalle(this.props.formValues.listaComprobanteDetalle)
                }

                if (form.recetaDetalles.length === 0) {
                    dialog.warning("Por favor agregue por lo menos 1 producto.");
                    return false;
                  }

                this.props.onSave(form, this.props.form);
            }
        });
    }

    
    fetchDetalle = (values) => {
    var result = [];

 /*    var keys = [];
    var obj = Object.assign({}, values.arrCantidad);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idProducto: values.arridProducto[key].key,
        idUnidadMedida: values.arridUnidadMedida[key].key,
        cantidad: parseFloat(values.arrCantidad[key]),
        descripcion: null
      });
    }); */

    values.forEach((key) => {
        result.push({
          idProducto: key.idProducto,
          idUnidadMedida: key.idUnidadMedida,
          cantidad: parseFloat(key.cantidad),
          descripcion: null
        });
      });


    return result;
  };


    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Receta de Producción" : "Modificar Receta de Producción"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="810px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    <div className="row">
                    <div className="col-md-3 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie,
                                            rules: [{
                                                required: true,
                                                message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento,
                                            rules: [{
                                                //required: true,
                                                //message: 'Requerido',
                                                whitespace: true
                                            }]
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-5 form-group">
                            <Form.Item label="Producto Terminado">
                                {getFieldDecorator('idProducto', {
                                    initialValue: this.props.formValues.idProducto ?
                                        { key: this.props.formValues.idProducto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione producto terminado"}
                                        optionFilterProp="children"
                                        onChange={(option) => {this.props.onChange("arrTerminado", option.key, null,0 );}}

                                    >
                                        {this.props.formValues.productos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Unidad Medida">
                              <span className="">{this.props.formValues.nombreUnidadMedida}</span>
                            </Form.Item>
                        </div>


                    </div>

            
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Descripción">
                                {getFieldDecorator('descripcion', {
                                    initialValue: this.props.formValues.descripcion,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Descripcion"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                   
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            onClick={this.props.onAgregarDetalle}
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Insumos" key="1">
                                     <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onRemove={this.props.onRemoverProducto}
                                        onChange={this.props.onChange}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        unidadMedida={this.props.formValues.unidadesMedida}
                                        productos={this.props.formValues.productos}
                                        onChangeNameProduct={this.props.handleChangeNameProduct}
                                    /> 
                                </TabPane>
               
                            </Tabs>
                        </div>
                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)